import { destroy as destroyRF, change } from 'redux-form'
import { destroy as destroySFM, prevFetch } from 'loankeeper-common/helpers/SimpleFetchManager'
//@ts-ignore
import { destroy as destroyLKG } from 'shared/LKGrid'
import { clientSearchAgain, destroyClientData } from 'src/store/client'
import { destroyApplicationsData } from 'src/store/application'

//@ts-ignore
export const obtainChangeField =
  (instanceName: string) =>
  (...args) =>
    //@ts-ignore
    change(instanceName, ...args)

export const closeClientGrid = (instanceName: string) => destroyLKG(instanceName)

export const closeSearchBar = (instanceName: string) => destroyRF(instanceName)

// export const deleteClients = (instanceName: string) => destroySFM(instanceName)

export const deleteClients = (instanceName: string) => {
  if (instanceName === 'ClientSearchGeneral') {
    return destroyClientData(instanceName)
  } else if (instanceName === 'ApplicationSearchGeneral') {
    return destroyApplicationsData(instanceName)
  }
  return destroySFM(instanceName)
}

export const destroy = (instanceName: string) => [
  closeClientGrid(instanceName),
  closeSearchBar(instanceName),
  deleteClients(instanceName),
]

// export const searchAgainClients = (instanceName: string, resolve: any, reject: any) =>
//   prevFetch({ instanceName, resolve, reject })
export const searchAgainClients = (instanceName: string, resolve: any, reject: any) => clientSearchAgain(instanceName)
